import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  pagination: {
    '& .MuiPaginationItem-root': {
      margin: 0
    },
    '& .MuiPagination-ul li:first-child button': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 0
    },
    '& .MuiPagination-ul li:last-child button': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 0
    },
    '& .MuiPagination-ul li:not(:last-child):not(:first-child) button': {
      borderRadius: 0
    }
  }
}))
